// External modules
import React, { useState } from 'react';
import {
  SegmentedController,
  SegmentedControllerPanel,
} from '@paypalcorp/pp-react-segmented-controller-weasley-v7';

// Internal modules
import { useFormList } from '../hooks';
import { useMountLogging } from '@/lib';

import { PaypalThemedProvider } from '@/styles';

export const TwoTabsComponent = (): React.ReactElement => {
  useMountLogging('SegmentedController');
  const { formList, initialSelectedTabIndex, onAfterTabChange, tabList } =
    useFormList();
  const [selectedIndex, setSelectedIndex] = useState(initialSelectedTabIndex);

  const clickTabHandler = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    tabIndex?: number,
  ) => {
    if (tabIndex !== undefined) {
      setSelectedIndex(tabIndex);
      onAfterTabChange(tabIndex);
    }
  };

  return (
    <PaypalThemedProvider>
      <SegmentedController
        data-testid="weasley-tabList"
        name="WeasleyTwoTabComponent"
        selectedTabIdx={selectedIndex}
        tabs={tabList}
        onClick={clickTabHandler}
        lazyLoad
      >
        {formList.map(({ tabId, form: Form }) => (
          <SegmentedControllerPanel id={tabId} tabId={tabId} key={tabId}>
            <Form />
          </SegmentedControllerPanel>
        ))}
      </SegmentedController>
    </PaypalThemedProvider>
  );
};
